/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_Consent_DescInputs */

const en_of_landing_consent_desc = /** @type {(inputs: Of_Landing_Consent_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose nearby audio, temporary chat, or a meeting. Record with participant consent, replay the private result, and draft AI summaries with source citations.`)
};

const id_of_landing_consent_desc = /** @type {(inputs: Of_Landing_Consent_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih audio sekitar, chat sementara, atau rapat. Rekam rapat dengan persetujuan peserta, putar hasil privatnya, dan buat draf ringkasan AI bersumber.`)
};

/**
* | output |
* | --- |
* | "Choose nearby audio, temporary chat, or a meeting. Record with participant consent, replay the private result, and draft AI summaries with source citations." |
*
* @param {Of_Landing_Consent_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_consent_desc = /** @type {((inputs?: Of_Landing_Consent_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_Consent_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_consent_desc(inputs)
	return en_of_landing_consent_desc(inputs)
});